import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballDesignatedHitter = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.03981 5.37988L7.89758 6.42312L7.34119 9.59145L6.11249 10.6347H2.55005L3.47737 5.37988H7.03981ZM5.62565 9.39826L6.04295 9.04279L6.4216 6.90996L6.18204 6.61631H4.65197L4.1574 9.39826H5.62565ZM12.0583 5.37988H13.4493L12.522 10.6347H11.131L11.4942 8.58686H9.65502L9.29182 10.6347H7.90084L8.82816 5.37988H10.2191L9.87139 7.35043H11.7106L12.0583 5.37988Z"
      fill="white"
    />
  </svg>
);
